module.exports = __webpack_public_path__ + "static/img/5.56f89bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/4/zh/5.png
// module id = Y9Tg
// module chunks = 0